var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import ChatTabsList from "./components/ChatTabsList";
import Conversation from "./components/Conversation";
import ConversationList from "./components/ConversationList";
import { getSessionStoragePrefs, removeSessionStoragePrefs, } from "./Storage";
import { OPENED_CHAT, OPENED_FLOW } from "./globals";
import InteractiveFlow from "./components/InteractiveFlow";
var LivechatComponentNames;
(function (LivechatComponentNames) {
    LivechatComponentNames["ConversationList"] = "ConversationList";
    LivechatComponentNames["Conversation"] = "Conversation";
    LivechatComponentNames["Flow"] = "Flow";
})(LivechatComponentNames || (LivechatComponentNames = {}));
export default function LiveChat(_a) {
    // const parentContext = useContext(AppContext);
    // const { sessions, setSessions } = parentContext;
    var loadingSessions = _a.loadingSessions, startNewChat = _a.startNewChat, openChat = _a.openChat, startFlow = _a.startFlow, addNewSession = _a.addNewSession;
    var componentName = getSessionStoragePrefs(OPENED_CHAT) != null
        ? LivechatComponentNames.Conversation
        : LivechatComponentNames.ConversationList;
    if (getSessionStoragePrefs(OPENED_CHAT) != null)
        componentName = LivechatComponentNames.Conversation;
    else if (getSessionStoragePrefs(OPENED_FLOW) != null)
        componentName = LivechatComponentNames.Flow;
    var _b = useState(LivechatComponentNames[componentName]), activeComponentName = _b[0], setActiveComponentName = _b[1];
    useEffect(function () {
        // setSessionStoragePrefs("chat_active_component", activeComponentName);
    }, [activeComponentName]);
    var showChatList = function () {
        removeSessionStoragePrefs(OPENED_CHAT);
        setActiveComponentName(LivechatComponentNames.ConversationList);
    };
    var showConversation = function () {
        setActiveComponentName(LivechatComponentNames.Conversation);
    };
    return (_jsxs(_Fragment, { children: [loadingSessions && !startNewChat ? (_jsxs(_Fragment, { children: [_jsx("div", { className: "chat__header" }), _jsx("div", __assign({ className: "chat__all-messages-track" }, { children: _jsx("p", __assign({ style: { marginTop: "60px", textAlign: "center" } }, { children: _jsxs("div", __assign({ className: "chat__form-loader1" }, { children: [_jsx("span", {}), _jsx("span", {}), _jsx("span", {}), _jsx("span", {})] })) })) }))] })) : (_jsx(_Fragment, { children: (function () {
                    if (activeComponentName === LivechatComponentNames.ConversationList) {
                        return (_jsx(ConversationList, { openChat: openChat, startNewChat: startNewChat, startFlow: startFlow }));
                    }
                    else if (activeComponentName === LivechatComponentNames.Conversation) {
                        return (_jsx(Conversation, { showChatsList: showChatList, addNewSession: addNewSession }));
                    }
                    else if (activeComponentName === LivechatComponentNames.Flow) {
                        return (_jsx(InteractiveFlow, { addNewSession: addNewSession, showConversation: showConversation }));
                    }
                    else {
                        return _jsx(_Fragment, { children: "None" });
                    }
                })() })), activeComponentName == LivechatComponentNames.ConversationList ? (_jsx(ChatTabsList, {})) : (_jsx(_Fragment, {}))] }));
}
